module.exports = __webpack_public_path__ + "static/media/cancel.73834b73.svg";